import { Injectable, NgZone } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Injectable({
    providedIn: 'root'
})
export class DialogUtils {

    constructor(private ngZone: NgZone) { }

    closeSidePanel<T>(dialogRef: MatDialogRef<T>, result?: any): void {
        const overlayPane = document.getElementById(dialogRef.id)?.closest('.side-panel');
        if (overlayPane) {
            overlayPane.classList.add('side-panel-closing');
            this.ngZone.runOutsideAngular(() => {
                setTimeout(() => {
                    this.ngZone.run(() => dialogRef.close(result));
                }, 300);
            });
        } else {
            dialogRef.close(result);
        }
    }
}
